<template>
  <v-main>
  <v-dialog
      v-model="this.$store.state.configuracoes.loading"
      hide-overlay
      persistent
      width="300"
    >
        <v-card
          elevation="24"
          class="d-flex flex-column align-center justify-center pa-6"
          style="
            border-radius: 20px;
            background: linear-gradient(135deg, rgba(67, 160, 71, 0.2), rgba(139, 195, 74, 0.85));
            backdrop-filter: blur(6px);
            box-shadow: 0 12px 28px rgba(67, 160, 71, 0.15);
            transition: all 0.3s ease;
          "
        >
          <v-progress-circular
            indeterminate
            size="70"
            width="6"
            color="white"
            class="mb-4"
          ></v-progress-circular>

          <div class="text-h6 font-weight-bold" style="color: white">
            Processando...
          </div>

          <!-- Opcional: barra de progresso sutil -->
          <!-- <v-progress-linear
            indeterminate
            color="white"
            height="4"
            rounded
            class="mt-4"
          ></v-progress-linear> -->
        </v-card>
    </v-dialog>
    <v-overlay :value="this.$store.state.configuracoes.loading"></v-overlay>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</v-main>
</template>
<script>
export default {};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>